import { render, staticRenderFns } from "./SithMesPrdProjectProfitCenterList.vue?vue&type=template&id=d2a20bf4&"
import script from "./SithMesPrdProjectProfitCenterList.vue?vue&type=script&lang=js&"
export * from "./SithMesPrdProjectProfitCenterList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports